import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { addIntegration, browserTracingIntegration, init } from '@sentry/angular';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Инициализируем Sentry только в production режиме
if (!isDevMode()) {
  init({
    dsn: 'https://cbcbd7df13e7c0003888bd09b4a63831@sentry.gogologins.com/15',
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 0.1,
    tracePropagationTargets: [],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  // Lazy-load replay after the page is interactive to keep it out of the initial bundle
  const loadReplay = (): Promise<void> =>
    import('@sentry/browser').then(({ replayIntegration }) => {
      addIntegration(replayIntegration());
    });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => loadReplay(), { timeout: 5000 });
  } else {
    setTimeout(loadReplay, 3000);
  }
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  // eslint-disable-next-line no-console
  console.error(err),
);
